import * as React from "react";
import { HeaderTheme } from "../components/Header";
import { SideNavigationTheme } from "../components/SideNavigation";

interface Theme {
  header?: HeaderTheme;
  sideNavigation?: SideNavigationTheme;
}

interface State extends Theme {
  change?(states: {[key: string]: any}): void;
}

const Context = React.createContext<State>({});

class ThemeContext extends React.Component<{}, State>{
  state: State = {
    header: HeaderTheme.LIGHT,
    sideNavigation: SideNavigationTheme.DARK,
    change: (states) => {
      this.setState(states);
    }
  };

  render() {
    const { state } = this;
    const { children } = this.props;

    return (
      <Context.Provider value={state}>
        { children }
      </Context.Provider>
    );
  }
}

export default ThemeContext;
export const ThemeContextConsumer = Context.Consumer;


// WEBPACK FOOTER //
// ./src/context/ThemeContext.tsx